import { MijnRoute } from '../mijn-navigatie.model';

export const ERROR: MijnRoute = {
    path: 'fout',
    navigationEvent: 'toFout',
    regex: /^\/fout$/
};
